import React from 'react';

import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import SupporterDetails from './SupporterDetails';

export type SupporterDetailsPlaceholderProps = {
  count: number;
  animated?: boolean;
};

export class SupporterDetailsPlaceholder extends React.PureComponent<
  SupporterDetailsPlaceholderProps
> {
  static defaultProps = {
    count: 1,
  };

  render() {
    const { count, animated } = this.props;
    const placeholdersArray = [];
    for (let i = 0; i < count; i += 1) {
      placeholdersArray.push(
        <SupporterDetails
          key={i}
          userName={
            <PlaceholderBar
              width="50%"
              colour="nobel"
              marginBottom="28px"
              animated={animated}
            />
          }
          message={
            <>
              <PlaceholderBar animated={animated} />
              <PlaceholderBar
                width="80%"
                marginBottom="26px"
                animated={animated}
              />
              <PlaceholderBar
                width="60%"
                marginBottom="17px"
                animated={animated}
              />
            </>
          }
        />,
      );
    }

    return placeholdersArray;
  }
}

export default SupporterDetailsPlaceholder;
